import api from "@/api/api";
import DoctorService from "./doctor";
import FileService from "./file";
import RequestService from "./request";
import SignService from "./sign";
import StudyService from "./study";
import AccountsService from "./account";
import PharmacyService from "./pharmacy";
import TextChatService from "./textChat";
import PaymentsService from "./payment";
import DicomService from "./dicom";
import FacilityService from "./facility";
import VideoChatService from "./video-chat";
import KomefAccountService from "./komef-account";

export enum ApiDoctor {
  DOCTOR = "/api/ApiDoctorsV2/Get",
  DOCTOR_LIST = "/api/ApiDoctorsV2/GetList",
  DOCTOR_PROFILE_IMAGE = "/api/ApiDoctorsV2/GetProfilePictureFile",
  DOCTOR_SCHEDULEDS = "/api/ApiDoctorReferV2/GetScheduleds",
  SAVE_MY_DOCTOR_INFO = "/api/ApiDoctorsV2/SaveMyDoctor",
  DEPTS_LIST = "/api/ApiDeptsV2/GetList",
  DOCTOR_ITEM = "/api/ApiDoctorsV2/DoctorItem",
  FACILITY_DOCTOR_LIST = "/api/ApiDoctorsV2/GetFacilityDoctors",
  FACILITY_DEPTS_LIST = "/api/ApiDeptsV2/GetFacilityDeptList",
}

export enum ApiFileManager {
  GET_FILE_LIST = "/api/ApiFileManagerV2/GetList",
  GET_STUDY_KEYS = "/api/ApiFileManagerV2/GetStudyKeys",
  DELETE_FILE = "/api/ApiFileManagerV2/Delete",
  GET_FILE = "/api/ApiFileManagerV2/GetFile",
}

export enum ApiRequest {
  REQUEST_LIST = "/api/ApiRequestListV2/GetMyList",
  GET_REQUEST = "/api/ApiRequestV2/Get",
  REQUEST_VIEW = "/api/ApiRequestV2/RequestView",
  REQUEST_LIST_ITEM = "/api/ApiRequestListV2/GetMyItem",
  GET_REQUEST_RESPONSE = "/api/ApiRequestResponseV2/GetResponse",
  GET_REQUEST_SUMMARY = "/api/ApiRequestV2/RequestSummary",
  SAVE = "/api/ApiRequestV2/Save",
  SAVE_QUICK = "/api/ApiRequestV2/SaveQuick",
  SAVE_SECOND_OPINION = "/api/ApiRequestV2/SaveSecondOpinion",
  CANCEL_REQUEST = "/api/ApiRequestV2/CancelRequest",
}

export enum ApiSign {
  SIGN_IN = "/api/ApiSign/Signin",
  SIGN_UP = "/api/ApiSign/Signup",
  Check_Possible_Email = "/api/ApiSign/CheckPossibleEmail",
  RESEND_EMAIL = "/api/ApiSign/ResendEmail",
  WITHDRAW = "/api/ApiSignV2/Withdraw",
  CHANGE_PASSWORD = "/api/ApiSignV2/ChangePassword",
  FORGOT_PASSWORD = "/api/ApiSign/ForgotPassword",
  RESET_PASSWORD = "/api/ApiSign/ResetPassword",
  CONFIRM_EMAIL = "/api/ApiSign/ConfirmEmail",
  SIGN_OUT = "/api/ApiSignV2/SignOut",
  GET_TOKEN = "/api/ApiSignV2/GetToken",
}

export enum ApiStudyData {
  BASE64_STUDY_THUMBNAIL = "/api/ApiStudyDataV2/GetBase64StudyThumbnail",
}

export enum ApiAccounts {
  USER_PROFILE = "/api/ApiAccountsV2/GetMyProfileData",
  GET_DEFAULT_PHARMACYKEY = "/api/ApiAccountsV2/GetMyDefaultPharmacyKey",
  ACCOUNT_INFO = "/api/ApiAccountsV2/GetAccountInfo",
  SET_LANGUAGE = "/api/ApiAccountsV2/SetLanguage",
  SAVE_MY_PROFILE = "/api/ApiAccountsV2/SetMyProfileData",
  SAVE_RRN = "/api/ApiAccountsV2/SetResidentRegNumber",
  GET_PROFILE_PICTURE = "/api/ApiAccountsV2/GetProfilePicture",
}

export enum ApiPharmacy {
  GET_PHARMACIES = "/api/ApiPharmacy/GetPharmacyList",
}

export enum ApiTextChat {
  GET_LASTMESSAGE = "/api/apiTextChat/GetLastChatMsgs",
}
export enum ApiPayments {
  GET = "/api/ApiPaymentsV2/GET",
  GET_READY = "/api/ApiPaymentsV2/GetReady",
  GET_MY_PAIDLIST = "/api/ApiPaymentsV2/GetList",
  GET_PAID = "/api/ApiPaymentsV2/GetPaid",
  GET_REQUEST_KEY = "/api/ApiPaymentsV2/GetRequestKey",
  SAVE_NICE = "/api/ApiPaymentsV2/SaveNice",
}
export enum ApiFacility {
  GET_HOSPITAL_LIST = "/api/ApiFacilityV2/GetHospitalList",
  GET_FACILITY = "/api/ApiFacilityV2/GetFacility",
}

export enum ApiVideoChat {
  GET_VIDEO_CHAT_URL = "/api/ApiVideoChatV2/GetVideoChatUrl",
  GET_GUEST_VIDEO_CHAT_URL = "/api/ApiVideoChatV2/GetGuestVideoChatUrl",
  GET_LINK_INFO = "/api/ApiVideoChatV2/GetLinkInfo",
  GET_LINK_ROOM_USERS = "/api/ApiVideoChatV2/GetLinkRoomUsers",
  VERIFY_LINK_PASSWORD = "/api/ApiVideoChatV2/VerifyLinkPassword",
}

export enum ApiKomef {
  LOGIN = "api/komef/account/login",
}

const $API = {
  DoctorService,
  FileService,
  RequestService,
  SignService,
  StudyService,
  AccountsService,
  PharmacyService,
  ApiPharmacy,
  TextChatService,
  PaymentsService,
  DicomService,
  FacilityService,
  VideoChatService,

  KomefAccountService,

  BaseURL: api.defaults.baseURL,
};

export default $API;
